import { createContext, use } from "react";
import type { IDrawerContextType } from "./types";

export const DrawerContext = createContext<IDrawerContextType>(
  {} as IDrawerContextType,
);

export const useDrawerContext = () => {
  return use(DrawerContext);
};
